/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import { Badge } from '@/components/ui/badge'
import { useAppointmentsList } from '@/hooks/useAppointments'

export const Route = createFileRoute('/_authenticated/service-cases/$id/appointments')({
  component: CaseAppointmentsTab,
})

function CaseAppointmentsTab() {
  const { id } = useParams({ from: '/_authenticated/service-cases/$id' })
  const navigate = useNavigate()
  const { data: appointmentsData } = useAppointmentsList({ service_case_id: id })
  const appointments = (appointmentsData as any)?.data ?? []

  if (appointments.length === 0) {
    return <p className="text-sm text-muted-foreground p-4">No appointments linked to this case.</p>
  }

  return (
    <div className="space-y-2">
      {appointments.map((a: any) => (
        <div key={a.id} className="p-3 border rounded-lg cursor-pointer hover:bg-muted/50" onClick={() => navigate({ to: `/appointments/${a.id}` })}>
          <div className="flex items-center justify-between">
            <span className="font-medium">{a.appointment_number}</span>
            <div className="flex gap-1"><Badge>{a.status}</Badge><span className="text-sm">{a.scheduled_date}</span></div>
          </div>
        </div>
      ))}
    </div>
  )
}
